// import "./style.less"; // Same styles are applied in date-control directive
export default function DateNav() {
    return {
        restrict: "E",
        scope: {
            search: "=", //object
        },
        template: require("./template.html"),

        controller: function (
            $scope,
            houseService,
            $rootScope,
            $filter,
            UrlFactory,
            searchBarFactory,
            moment
        ) {
            // Set filter
            $scope.searchFilter = houseService.searchFilter;

            var bookingAddedEventListener = $rootScope.$on(
                "update-date-broadcast",
                function (event, obj) {
                    if (obj.tooltip) {
                        $scope.glimpseDateTooltip();
                    }
                }
            );
            $scope.$on("$destroy", bookingAddedEventListener);

            $scope.glimpseDateTooltip = function () {
                $scope.showDateTooltip = true;

                setTimeout(function () {
                    $scope.$apply(function () {
                        $scope.showDateTooltip = false;
                    });
                }, 2500);
            };

            // $scope.toogleTooltip = function($event){

            //     if(!$scope.showDateTooltip){

            //          $scope.showDateTooltip = true;

            //     }else{

            //         $scope.showDateTooltip = false;

            //     }

            // }

            $scope.activateSearchBarInput = function (oSearchInputIndex) {
                // OPEN DROPDOWN IN SEARCHBAR
                $rootScope.$broadcast(
                    "activate-searchbar-dropdown-broadcast",
                    oSearchInputIndex
                );
            };

            $scope.closeTooltip = function ($event) {
                $event.preventDefault();

                $scope.showDateTooltip = false;
            };

            $scope.goToXDaysFromToday = function (xDays, search) {
                const newDate = moment(search.start, "DD-MM-YYYY")
                    .add(xDays, "days")
                    .format("DD-MM-YYYY");

                houseService.searchFilter.startDate = newDate; // update the API param
                houseService.searchFilter.startTime = angular.copy(
                    houseService.calenderFilter.startTime()
                ); // update the API param

                houseService.calenderFilter.selectedDate = newDate; //update searchbar calender display value
                // Update searchBar user selected date!
                $scope.oSearchCalender = searchBarFactory.get_oSearchCalender();
                $scope.oSearchCalender.userSelected.date = newDate; // will bind to (houseService.searchFilter.startDate) when clicking search in search Bar

                // update the calender
                $rootScope.$broadcast("update-date-broadcast", {
                    date: newDate,
                    tooltip: false,
                });

                // $("#datepicker").datepicker("setDate", newDate);

                const dateToGo = moment(search.date, "DD-MM-YYYY")
                    .add(xDays, "days")
                    .format("DD-MM-YYYY");

                UrlFactory.setRoute(
                    search.activity,
                    search.location,
                    dateToGo,
                    search.start,
                    search.end,
                    search.hours,
                    search.weeks
                );
                // searchBarFactory.searchBroadcast();
                //houseService.searchFilter.searchNow();
            };

            $scope.xDaysFromNow = function (xDays) {
                // Used To hide The callers element ( date change Arrow )

                var today = $filter("date")(Date.now(), "dd-MM-yyyy");
                var selectedDateTimestamp = moment(
                    houseService.searchFilter.startDate,
                    "DD-MM-YYYY"
                ).format("X");
                var xDaysFromNowTimestamp = moment(today, "DD-MM-YYYY")
                    .add(xDays, "days")
                    .format("X");

                if (selectedDateTimestamp - xDaysFromNowTimestamp < 0) {
                    return true;
                }

                return false;
            };

            $scope.isItToday = function () {
                if (
                    houseService.searchFilter.startDate ==
                    $filter("date")(Date.now(), "dd-MM-yyyy")
                ) {
                    return true;
                }
                return false;
            };
        },
    };
}
